export const hideHeaderOn: string[] = ["exemple", "grid", "feed"];
export const hideContentOn: string[] = [""];
export const hideFooterOn: string[] = ["exemple", "grid"];
export const carouselOn: string[] = ["feed"];
